import iflFlatFormDictionary from '../../ru/ifl-flat-form/ifl-flat-form.dic.json';

export const iflFlatFormNS = {
  IFL_FLAT_FORM: iflFlatFormDictionary,
};

export const iflFlatFormNamespaces = ['IFL_FLAT_FORM'];
